module.exports = __webpack_public_path__ + "img/Guatemala.58255a59.svg";